import { Context } from '@nuxt/types';
import { Inject } from '@nuxt/types/app';
import * as display from '~/display';

export default function (_: Context, inject: Inject) {
  inject('display', display);
}
